// extracted by mini-css-extract-plugin
export var container = "ProjectCard-module--container--2j4nw";
export var images = "ProjectCard-module--images--1g0Bv";
export var imgWrapper = "ProjectCard-module--imgWrapper--2lapO";
export var text = "ProjectCard-module--text--xgrbV";
export var title = "ProjectCard-module--title--3VfPc";
export var subtitle = "ProjectCard-module--subtitle--2nTAb";